/* ABC: автолистание баннеров.
   Штатный таймер темы не срабатывает (autoplay=true, интервал 5000, но слайд не меняется),
   при этом метод next() у компонента работает. Поэтому крутим сами:
   — пауза, когда слайдер вне экрана или вкладка неактивна;
   — пауза при наведении и при касании;
   — клик по левой/правой трети слайда листает назад/вперёд;
   — свайп пальцем и мышью. */
(function () {
  var INTERVAL = 7000;   // владелец: раз в 7 секунд

  function init(comp) {
    if (!comp || comp.dataset.abcAuto) return;
    comp.dataset.abcAuto = '1';

    // Простой таймер без наблюдателей: видимость и наведение проверяем в момент тика.
    // Вариант с IntersectionObserver не запускался, а next() при этом работал.
    /* 27.09: таймер останавливается, если слайдер убрали со страницы (редактор темы) */
    var timer = setInterval(function () {
      if (!comp.isConnected) { clearInterval(timer); return; }
      if (document.hidden) return;
      var r = comp.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;   // вне экрана
      try { if (comp.matches(':hover')) return; } catch (e) {}   // курсор на баннере
      go(1);
    }, INTERVAL);

    /* БЕСКОНЕЧНАЯ ЛЕНТА (владелец: всегда вперёд, без перемотки и без
       растворения). В конец ленты кладём КОПИЮ первого баннера. С последнего
       баннера едем обычной прокруткой на копию, а как доехали — мгновенно и
       незаметно встаём на настоящий первый (он выглядит так же). Назад с
       первого — наоборот: мгновенно на копию, затем прокруткой на последний.
       Баннеры не переставляются; во время перехода нажатия не принимаются. */
    var busy = false;
    function all() { return [].slice.call(comp.querySelectorAll('slideshow-slide')); }
    function realCount() { return all().filter(function (x) { return !x.dataset.abcClone; }).length; }
    /* номер баннера — по положению прокрутки (надёжнее, чем отметка темы) */
    function curIndex() {
      var box = comp.querySelector('slideshow-slides');
      if (box && box.clientWidth) return Math.round(box.scrollLeft / box.clientWidth);
      var i = all().findIndex(function (x) { return x.getAttribute('aria-hidden') === 'false'; });
      return i < 0 ? (comp.current || 0) : i;
    }
    function lock(ms) { busy = true; setTimeout(function () { busy = false; }, ms); }
    /* мгновенный прыжок: сами ставим прокрутку без анимации (у ленты
       плавная прокрутка в CSS, и select темы иногда «ехал» назад) */
    function jump(i) {
      var box = comp.querySelector('slideshow-slides'), el = all()[i];
      if (box && el) {
        var prevB = box.style.scrollBehavior, prevS = box.style.scrollSnapType;
        box.style.scrollBehavior = 'auto';
        box.style.scrollSnapType = 'none';
        box.scrollLeft = box.scrollLeft + el.getBoundingClientRect().left - box.getBoundingClientRect().left;
        box.getBoundingClientRect();
        box.style.scrollSnapType = prevS;
        box.style.scrollBehavior = prevB;
      }
      try { comp.select(i, undefined, { animate: false }); } catch (e) {}
    }
    function ensureClone() {
      var list = all();
      if (list.length < 2 || list.some(function (x) { return x.dataset.abcClone; })) return;
      var copy = list[0].cloneNode(true);
      copy.dataset.abcClone = '1';
      copy.setAttribute('slide-id', 'abc-clone');
      copy.setAttribute('aria-hidden', 'true');
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      /* фото копии — тот же файл, что у первого; грузится вместе с остальными слайдами (warm) */
      copy.querySelectorAll('img').forEach(function (img, k) {
        var src = list[0].querySelectorAll('img')[k];
        img.removeAttribute('fetchpriority');
        if (warmed) img.loading = 'eager';
        if (src && src.currentSrc) { img.removeAttribute('srcset'); img.src = src.currentSrc; }
      });
      list[list.length - 1].after(copy);
    }
    /* 27.09: слайды 2–3 (и копия первого) в разметке «ленивые» — не мешают первому экрану.
       Догружаем их, когда страница загрузилась и слайдер рядом на экране (или при первом
       касании/листании) — к первому перелистыванию фото уже готово, без белого кадра.
       (Ленивые фото в горизонтальной ленте браузер сам не грузит, пока их не прокрутят.) */
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      all().forEach(function (sl) { sl.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; }); });
    }
    /* на ПК страница прокручивается внутри .page-wrapper, а не окном — «рядом» считаем по нему */
    function scroller() {
      for (var p = comp.parentElement; p && p !== document.body; p = p.parentElement) {
        var o = getComputedStyle(p).overflowY;
        if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight) return p;
      }
      return null;
    }
    function watchNear() {
      if (warmed) return;
      if (!('IntersectionObserver' in window)) { warm(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); warm(); }
      }, { root: scroller(), rootMargin: '100% 0px 100% 0px' });
      io.observe(comp);
    }
    if (document.readyState === 'complete') watchNear();
    else window.addEventListener('load', watchNear, { once: true });
    comp.addEventListener('pointerdown', warm, { once: true, passive: true });
    ensureClone();
    function go(dir) {
      if (busy || typeof comp.select !== 'function') return;
      warm();
      ensureClone();
      var n = realCount(), cur = curIndex();
      if (n < 2) return;
      lock(800);
      if (dir > 0) {
        if (cur >= n) { jump(0); cur = 0; }
        comp.select(cur + 1);                     // на копию, если были на последнем
        if (cur + 1 === n) setTimeout(function () { jump(0); }, 750);
      } else {
        if (cur <= 0) { jump(n); setTimeout(function () { comp.select(n - 1); }, 30); }
        else comp.select(cur - 1);
      }
    }
    /* пальцем доехали до копии — так же незаметно на настоящий первый */
    var sc = comp.querySelector('slideshow-slides');
    var st = 0;
    if (sc) sc.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { if (!busy && curIndex() >= realCount()) jump(0); }, 180);
    }, { passive: true });

    // клик по краю листает, свайп тоже
    var x0 = null, y0 = null, moved = false;
    comp.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; moved = false; });
    comp.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      if (Math.abs(e.clientX - x0) > 12) moved = true;
    });
    comp.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      var r = comp.getBoundingClientRect();

      if (moved && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        /* пальцем тема листает сама (прокрутка) — вмешиваемся только на
           краях, иначе получался двойной перелист и «ломались» баннеры */
        if (e.pointerType === 'mouse') { dx < 0 ? go(1) : go(-1); }
        else if (dx > 0 && curIndex() <= 0) { go(-1); }   /* назад с первого пальцем */
      } else if (!moved && !e.target.closest('a,button')) {
        var rel = (e.clientX - r.left) / r.width;
        if (rel > 0.75) go(1);
        else if (rel < 0.25) go(-1);
      }
      x0 = y0 = null;
    });

  }

  function scan() {
    /* ВАЖНО: только баннерная секция. Раньше здесь был голый
       'slideshow-component', и автопрокрутка цеплялась к каждой галерее
       в карточках каталога — фотографии там переключались сами.
       В карточке листать должен только человек. */
    document.querySelectorAll('[id*="abc_slideshow"] slideshow-component').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
